<template>
  <div
    class="wc-dialog-overlay"
    v-if="props.modelValue"
    @click.self="handleClose"
    @touchmove.prevent
    @wheel.prevent
  >
    <div class=" login-dialog" @touchmove.stop @wheel.stop>
      <div class="wc-dialog-header">
        <img :src="loginTitle" class="login-title" />
      </div>
      <div class="wc-dialog-body">
        <div class="login-content">
        <div class="form-item">
          <label>{{ $t("wc2026.accountId") }}</label>
          <input
            v-model="state.account"
            type="text"
            :placeholder="$t('wc2026.accountId')"
            class="wc-input"
          />
        </div>
        <div class="form-item">
          <label>{{ $t("wc2026.login.inputCode") }}</label>
          <div class="code-row">
            <input
              v-model="state.code"
              type="text"
              :placeholder="$t('wc2026.login.inputCode')"
              class="wc-input code-input"
              maxlength="6"
            />
            <button
              class="send-code-btn"
              :disabled="state.countdown > 0"
              @click="handleSendCode"
            >
              {{
                state.countdown > 0
                  ?  state.countdown
                  : $t("wc2026.login.sendCode")
              }}
            </button>
          </div>
        </div>
      </div>
        <div class="confirm-actions flex-center">
          <div class="wc-btn secondary btn" @click="handleClose">
            {{ $t("wc2026.login.cancel") }}
          </div>
          <div class="wc-btn primary btn" @click="handleLogin">
            {{ $t("wc2026.login.submit") }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
/* eslint-disable */
import { reactive, defineProps, defineEmits, watch, computed, onUnmounted } from "vue";
import { useStore } from "vuex";
import { toastService } from "@/utils/toastService";
import { useI18n } from "vue-i18n";
import WcApi from "@/config/wcActApi";

// 禁止/恢复页面滚动
const lockScroll = () => {
  document.body.classList.add('no-scroll')
  document.documentElement.classList.add('no-scroll')
}

const unlockScroll = () => {
  document.body.classList.remove('no-scroll')
  document.documentElement.classList.remove('no-scroll')
}
import loginTitleVi from "@/assets/imgs/act/wc2026/loginDialog/titlevi.png";
import loginTitleTh from "@/assets/imgs/act/wc2026/loginDialog/titleth.png";
import loginTitleId from "@/assets/imgs/act/wc2026/loginDialog/titleid.png";
import loginTitleZh from "@/assets/imgs/act/wc2026/loginDialog/titlezh.png";
import loginTitleEn from "@/assets/imgs/act/wc2026/loginDialog/titleen.png";

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["update:modelValue", "loginSuccess"]);
const store = useStore();
const { t } = useI18n();
const locale = useI18n().locale;
const loginTitle = computed(() => {

  switch (locale.value) {
    case "vi":
      return loginTitleVi;
    case "th":
      return loginTitleTh;
    case "id":
      return loginTitleId;
    case "en":
      return loginTitleEn;
    case "tw":
      return loginTitleZh;
    case "hk":
      return loginTitleZh;
    default:
      return loginTitleEn;
  }
});

const state = reactive({
  account: "",
  code: "",
  countdown: 0,
  timer: null,
});

const handleClose = () => {
  emit("update:modelValue", false);
};

const startCountdown = () => {
  state.countdown = 60;
  state.timer = setInterval(() => {
    state.countdown--;
    if (state.countdown <= 0) {
      clearInterval(state.timer);
      state.timer = null;
      state.countdown = 0;
    }
  }, 1000);
};

const handleSendCode = async () => {
  if (!state.account) {
    toastService.show(t("wc2026.login.emailPlaceholder"));
    return;
  }
  if (state.countdown > 0) return;
  try {
    await WcApi.sendMailCode({ uid: state.account.toUpperCase() });
    startCountdown();
    toastService.show(t("wc2026.login.codeSent"));
  } catch (e) {
    console.error(e);
  }
};

const handleLogin = async () => {
  if (!state.account) {
    toastService.show(t("wc2026.login.emailPlaceholder"));
    return;
  }
  if(!state.code) {
    toastService.show(t("wc2026.login.codePlaceholder"));
    return;
  }
  try {
    const res = await WcApi.loginByMailCode({
      uid: state.account.toUpperCase(),
      code: state.code,
    });
    if (res && res.authorization) {
      store.commit("SET_ACTIVITY_TOKEN", res.authorization);
      store.commit("SET_CP_USER_INFO", {
        cpUserId: res.roleInfo?.uin,
        nickname: res.roleInfo?.nickname,
        expireAt: res.expireAt,
        ...res.roleInfo,
      });
      emit("loginSuccess");
      emit("update:modelValue", false);
      toastService.show(t("wc2026.login.loginSuccess"));
    }
  } catch (e) {
    console.error(e);
    toastService.show(t("wc2026.login.codeError"));
  }
};

watch(
  () => props.modelValue,
  (val) => {
    if (val) {
      lockScroll()
    } else {
      unlockScroll()
      state.account = "";
      state.code = "";
      if (state.timer) {
        clearInterval(state.timer);
        state.timer = null;
        state.countdown = 0;
      }
    }
  },
  { immediate: true }
);

onUnmounted(() => {
  unlockScroll()
})
</script>

<style lang="less" scoped>
@import "../shared.less";

.login-dialog {
  width: 673px;
  height: 439px;
  background-image: url("~@/assets/imgs/act/wc2026/dialog/bg.png");
  .login-title {
    height: 47px;

    width: auto;
    display: block;
    margin: auto;
    margin-top: 12px;
  }
  .login-content {
    margin-bottom: 77px;
    margin-top: 77px;
    padding-left: 31px;
    padding-right: 25px;
  }
  .form-item {
    display: flex;
    height:47px;
    margin-bottom: 41px;
    align-items: center;
    &:last-child {
      margin-bottom: 0;
    }
    label {
      display: block;
      width: 185px;
      flex-shrink: 0;
      font-size: 24px;
      color: #1B0926;
      margin-right: 19px;
     
    }

    .code-row {
      display: flex;
      gap: 14px;

      .code-input {
        flex: 1;
      }

      .send-code-btn {

        padding: 0 24px;
        background: #4caf50;
        color: #1B0926;
        border: none;
        border-radius: 10px;
        font-size: 17px;
        font-weight: bold;
        cursor: pointer;
        transition: opacity 0.2s;
        height: 46px;
        width: 225px;

        &:disabled {
          opacity: 0.5;
          cursor: not-allowed;
        }

        &:not(:disabled):hover {
          background: #43a047;
        }
      }
    }
  }


  .confirm-actions {
    margin-top: 28px;
    display: flex;
    justify-content: center;
    gap: 47px;
  }
}
</style>
